import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import { Accordion, Form, Button, Modal } from "react-bootstrap";
import "./CheckOutNew.css";
import {validatecheckoutnew} from '../../Utils/validate';
import loader from '../../assests/loader.gif';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import API from '../../Utils/Api';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
//const stripePromise = loadStripe('pk_test_51S5isFLKaHKOMWcoPp2chF7oTMkhXPW6CwwP8Okn1bsv6a44GtwrEYtH2ZuwvDWZ7Q4RpRVtg3qRRwyOJht1jh8E00nIrr8kJr');

const CheckOutNew = () => {
 
  const [loading,setLoading] = useState(true);

  const [inputsche,setInputsche] = useState({email:'',first_name:'',last_name:'',accept_terms:0});

  const [showFirst, setShowFirst] = useState(false);

  const [errors,setErrors] = useState({});

  const [activeKey, setActiveKey] = useState("0");
  
  
  const [isEditing, setIsEditing] = useState(true);

  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3;

  const nextStep = () => {
    if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
  };

  
  const savedCart = localStorage.getItem("cartItems");
  const [cartItems, setCartItems] = useState(JSON.parse(savedCart) || []);

  useEffect(() => {
    document.title = `CheckOut | Your Friend My Friend`;
    document.getElementById('bodywrap').className='checkout';

    localStorage.setItem("prev_page", '/check-out-new/');

     if(localStorage.getItem('checkout_data'))
    {
      var intp=JSON.parse(localStorage.getItem('checkout_data'));
      
      setInputsche(
        {
          email:intp.email,
          first_name:intp.first_name,
          last_name:intp.last_name,
          accept_terms:intp.accept_terms
        });
      
    }

    
    if(localStorage.getItem('auth_token'))
    {
      const savedCart = localStorage.getItem("cartItems");
      let formData = new FormData();
      formData.append('course_data', savedCart);
      API.post('check_cart_item',formData)
            .then(response => {
              setLoading(false);
          if(response.data.status === false){
            
          }else{
              const newCart = response.data.data;

                // Replace cart in state
                setCartItems(newCart);

                // Replace cart in localStorage
                localStorage.setItem("cartItems", JSON.stringify(newCart));

                // If new cart empty → redirect
                if (!newCart || newCart.length === 0) {
                  localStorage.removeItem("cartItems");
                  window.location.href = "/dating-masterclass";
                }
          }                  
        }).catch(error => {
           setLoading(false);
        });
      }else{
        setLoading(false);
        const savedCart = localStorage.getItem("cartItems");
        setCartItems(JSON.parse(savedCart));
        if (!savedCart || savedCart.length === 0) {
          window.location.href = "/dating-masterclass";
        }
      }

  },[]); 




  /* Start Value set */
const handleInputChange = (event) => {
      event.persist();
      setInputsche(inputsche => ({...inputsche, [event.target.name]: event.target.value})); 
      if(localStorage.getItem('checkout_data'))
      {
        localStorage.removeItem("checkout_data");
      }
}
const handleInputChangeCustom = (field, value) => {

    if(value)
    {
      setInputsche({ ...inputsche, [field]: 1 });
    }else{
      setInputsche({ ...inputsche, [field]: 0 });
    }
  }
const step1 = () => {
  const validationErrors = validatecheckoutnew(inputsche);
  const noErrors = Object.keys(validationErrors).length === 0;
  setErrors({});
  setErrors(validationErrors);
  if(noErrors){
    if(localStorage.getItem('auth_token'))
    {
      setLoading(false);
      setActiveKey('1');
      setIsEditing(false);
    }else{
      localStorage.setItem("checkout_data", JSON.stringify(inputsche));
       window.location.href = "/login";
    }
  }
}

const nextStep1 = () => {
  const validationErrors = validatecheckoutnew(inputsche);
  const noErrors = Object.keys(validationErrors).length === 0;
  setErrors({});
  setErrors(validationErrors);
  if(noErrors){
    if(localStorage.getItem('auth_token'))
    {
      setLoading(false);
      if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
      setActiveKey("1");
    }else{
      localStorage.setItem("checkout_data", JSON.stringify(inputsche));
       window.location.href = "/login";
    }
  }
}

const LeaveUrl = () => {
  setLoading(true);
      window.location.href = '/dating-masterclass';
}
const LeaveUrl1 = () => {
    setLoading(false);
    setCurrentStep(1);
  }
  const LeaveUrl2 = () => {
    setLoading(false);
    setCurrentStep(2);
  }

  return (
    <>
      <div className="container-fluid out om d-none d-md-block">
        <div className="text-left mb-4" >
          <img src="/assests/images/back-top-logo.png" alt="back-logo" />
        </div>
        <div className="hyy mb-4">
          <button className="custom-close pora p-0 pt-2" onClick={() => { setShowFirst(true); }}>
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/clo-ti.svg'}
              alt="Close"
              style={{ width: "18px" }}
            />
          </button>
        </div>
        <div className="row">
          <div className="col-md-7">
            <Accordion activeKey={activeKey}>
              <Accordion.Item eventKey="0">
                <Accordion.Header onClick={() => setActiveKey("0")}>
                  <div className="w-100">
                    <div className="w-100 mb-3">1. Contact information</div>
                    {!isEditing && (
                      <div className="d-flex justify-content-between align-items-center after">
                        <span>{inputsche.email || "Enter your email"}</span>
                        <Link
                          className=""
                          variant="link"
                          onClick={() => {
                            setIsEditing(true);
                            setActiveKey("0");
                          }}
                        >
                          Edit
                        </Link>
                      </div>
                    )}
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  {isEditing ? (
                    <Form>
                      <div className="row g-3 mb-3">
                        <div className="col-md-12">
                          <Form.Group controlId="email">
                            <Form.Label>Email *</Form.Label>
                            <Form.Control
                              type="email"
                              value={inputsche.email}
                              placeholder="Enter email"
                              name="email"
                              onChange={handleInputChange}
                            />
                            {errors.email && (<p className="text-danger">{errors.email}</p>)}
                          </Form.Group>
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <Form.Group controlId="firstName">
                            <Form.Label>First name *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.first_name}
                              placeholder="First Name"
                              name="first_name"
                              onChange={handleInputChange}
                            />
                            {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group controlId="lastName">
                            <Form.Label>Last Name *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.last_name}
                              placeholder="Last Name"
                              name="last_name"
                              onChange={handleInputChange}
                            />
                            {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
                          </Form.Group>
                        </div>
                      </div>
                      <div className="form-check mt-3 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          className={`form-check-input`}
                          id="subscribe"
                          name="accept_terms"
                          value={inputsche.accept_terms ? '1' : ''}
                          checked={inputsche.accept_terms}
                          onChange={(event) => handleInputChangeCustom('accept_terms', event.target.checked)}
                          style={{ width: 16, height: 16 }}
                        />
                        <label className="form-check-label" htmlFor="accept_terms">
                          I agree to the YFMF Masterclass <span className="undu-linung"><Link to="/terms-conditions" className="text-decoration-none" target="_blank">Terms and Conditions</Link></span>
                        </label>
                      </div>
                      {errors.accept_terms && (
                        <p className="text-danger error-text">{errors.accept_terms}</p>
                      )}
                      <Button
                        className="mt-4 w-100 ne"
                        onClick={() => step1()}>
                        NEXT STEP
                      </Button>
                    </Form>
                  ) : null}
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>2. Payment</Accordion.Header>
                <Accordion.Body>
                  <Elements stripe={stripePromise}>
                  <CheckoutForm inputsche={inputsche} cartitems={cartItems} />
                </Elements>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>

          <div className="col-md-1"></div>

          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h5 className="jurak">Order Summary</h5>
                {cartItems.map((val, i) => (
                <div className="d-flex justify-content-between align-items-center gap-4 mb-4">
                  <div>
                    <h6>
                      Dating Masterclass with {val.coach_name}
                    </h6>
                    <p>
                      {val.name}
                    </p>
                  </div>
                  <div className="krice">€{val.price}</div>
                </div>
                ))}
                <hr />
                <h4 className="dhirak chk-box-total">
                  <div>Total</div> 
                  <div className="text-end">
                    <div className="">€{cartItems
              .reduce((total, item) => total + parseFloat(item.price || 0), 0)
              .toFixed(2)}</div>
                    <div className="mt-1 warx">Price includes 23% VAT</div>
                  </div>
                </h4>
              </div>
            </div>

            {/* <Button className="mt-4 ne" onClick={() => { setShowFirst(true); }}>
              Leave Checkout
            </Button> */}
            
          </div>
        </div>
      </div>

      <Modal
        show={showFirst}
        onHide={() => setShowFirst(false)}
        centered
        size="lg"
        className="newyesrt"
      >
        <div className="leav">
          <div className="close-btn" onClick={() => setShowFirst(false)}>
            <X size={30} />
          </div>
          <Modal.Body className="text-center p-4">
            <h4>Leave checkout?</h4>
            <p>
              Are you sure you want to leave checkout? <br></br>
              The item you’ve selected may not be available later
            </p>
            <div className="d-flex justify-content-center gap-2 noyle">
              <Button type="button" className="w-100 st" onClick={() => setShowFirst(false)}>STAY</Button>
              <Button type="button" className="w-100 le" onClick={() => { LeaveUrl(); }}>
                LEAVE
              </Button>
            </div>
          </Modal.Body>
        </div>
      </Modal>

      {/* Mobile Step View */}
      <div className="d-block d-md-none">
        {/* Step Content */}
        {currentStep === 1 && (
          <div className="container-fluid out om d-flex flex-column vh-100">
            <div className="row text-center mb-5">
                <button className="custom-close p-0 pt-2" onClick={() => { setShowFirst(true); }}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/clo-ti.svg'}
                    alt="Close"
                    style={{ width: "18px" }}
                  />
                </button>
            </div>

            <div className="row ">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body align-items-start">
                    {/*<div className="hyy" onClick={() => { setShowFirst(true); }}>
                      <Link
                        className="holo"
                      >
                        <img src="/assests/images/back.png" alt="Back" />
                      </Link>
                    </div>*/}
                    <h5 className="jurak">Order Summary</h5>
                    {cartItems.map((val, i) => (
                <div className="d-flex justify-content-between align-items-center gap-4 mb-4">
                  <div>
                    <h6>
                      Dating Masterclass with {val.coach_name}
                    </h6>
                    <p>
                      {val.name}
                    </p>
                  </div>
                  <div className="krice">€{val.price}</div>
                </div>
                ))}
                    <hr />
                    <h4 className="dhirak chk-box-total">
                      <div>Total</div> 
                      <div className="text-end">
                        <div className="">€{cartItems
              .reduce((total, item) => total + parseFloat(item.price || 0), 0)
              .toFixed(2)}</div>
                        <div className="mt-1 warx">Price includes 23% VAT</div>
                      </div>
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            <div className="row pb-4">
              <div className="col-md-12">
                {/* <h4>
                  Total <span className="float-end">€147.06</span>
                </h4> */}
                <Button
                  className="mt-5 w-100 ne"
                  onClick={() => {
                    nextStep();
                  }}
                >
                  CHECKOUT
                </Button>
              </div>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div className="container-fluid out d-flex flex-column vh-100">
            <div className="row text-center mb-5">
                <button className="koma-se" onClick={() => { LeaveUrl1(); }} >
                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/back.png'} alt="Back" />
                </button>
              <button className="custom-close p-0 pt-2" onClick={() => { setShowFirst(true); }}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/clo-ti.svg'}
                    alt="Close"
                    style={{ width: "18px" }}
                  />
                </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <Accordion activeKey={activeKey}>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header onClick={() => setActiveKey("0")}>
                      <div className="w-100">
                        {/*<div className="hyy">
                          <Link
                            className="holo"
                            onClick={() => { setShowFirst(true); }}
                          >
                            <img src="/assests/images/back.png" alt="Back" />
                          </Link>
                        </div>*/}
                        <div className="w-100">1. Contact information</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Form>
                        <div className="row g-3 mb-3">
                          <div className="col-md-12">
                            <Form.Group controlId="email">
                              <Form.Label>Email *</Form.Label>
                              <Form.Control
                                type="email"
                                value={inputsche.email}
                                name="email"
                                onChange={handleInputChange}
                                placeholder="Enter email"
                              />
                              {errors.email && (<p className="text-danger">{errors.email}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <Form.Group controlId="firstName">
                              <Form.Label>First name *</Form.Label>
                              <Form.Control
                                type="text"
                                value={inputsche.first_name}
                                name="first_name"
                                onChange={handleInputChange}
                                placeholder="First Name"
                              />
                              {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group controlId="lastName">
                              <Form.Label>Last Name *</Form.Label>
                              <Form.Control
                                type="text"
                                value={inputsche.last_name}
                                name="last_name"
                                onChange={handleInputChange}
                                placeholder="Last Name"
                              />
                              {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        <div className="form-check mt-3 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          className={`form-check-input`}
                          id="subscribe"
                          name="accept_terms"
                          value={inputsche.accept_terms ? '1' : ''}
                          checked={inputsche.accept_terms}
                          onChange={(event) => handleInputChangeCustom('accept_terms', event.target.checked)}
                          style={{ width: 16, height: 16 }}
                        />
                        <label className="form-check-label" htmlFor="accept_terms">
                          I agree to the YFMF Masterclass <span className="undu-linung"><Link to="/terms-conditions" className="text-decoration-none" target="_blank">Terms and Conditions</Link></span>
                        </label>
                      </div>
                      {errors.accept_terms && (
                        <p className="text-danger error-text">{errors.accept_terms}</p>
                      )}
                      </Form>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>

            <div className="row pb-4">
              <div className="col-md-12">
                <Button
                  className="mt-3 w-100 ne"
                 onClick={() => nextStep1()}
                >
                  NEXT STEP
                </Button>
              </div>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div className="container-fluid out d-flex flex-column vh-100">
            <div className="row text-center mb-5">
                <button className="koma-se" onClick={() => { LeaveUrl2(); }} >
                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/back.png'} alt="Back" />
                </button>
                <button className="custom-close p-0 pt-2" onClick={() => { setShowFirst(true); }}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/clo-ti.svg'}
                    alt="Close"
                    style={{ width: "18px" }}
                  />
                </button>
            </div>

            <div className="row flex-grow-1">
              <div className="col-md-12">
                <Accordion activeKey={activeKey}>
                  <Accordion.Item eventKey="1">
                    {/*<div className="hyy">
                      <Link
                        className="holo"
                        onClick={() => { setShowFirst(true); }}
                      >
                        <img src="/assests/images/back.png" alt="Back" />
                      </Link>
                    </div>*/}
                    <Accordion.Header>2. Payment</Accordion.Header>
                    <Accordion.Body>
                      <Elements stripe={stripePromise}>
                  <CheckoutForm inputsche={inputsche} cartitems={cartItems} />
                </Elements>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>

          </div>
        )}
      </div>
      {loading && (
       <div className="loadingClass">
        <img src={loader} alt="loader"/>
      </div>
       )} 
    </>
  );
};

export default CheckOutNew;
